import React from "react";
import "./MovieDetailsPage.scss";
import MovieDetails from "../components/home/movies/MovieDetails";

const MovieDetailsPage = () => {
  return (
    <div className="movie-details-page">
      <MovieDetails />
    </div>
  );
};

export default MovieDetailsPage;
